import { createSlice } from '@reduxjs/toolkit';
import { IUserWidget } from '../interfaces';
import { getIsChina } from '../../../../domain/hidden-data-provider';
import { getGdprCookie } from '../../../gdpr/domain/gdpr-provider';

interface IState{
    shareUrl: string;
    userWidget: IUserWidget|null;
    emailFormVisible: boolean;
    isChina: boolean;
    isGdprFunctional: boolean;
}

const gdpr = getGdprCookie();

/**
 * initial state
 */
const initialState: IState = {
    shareUrl: '',
    userWidget: null,
    emailFormVisible: false,
    isChina: getIsChina(),
    isGdprFunctional: gdpr.IsFunctional,
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
    }
});

export default rootSlice;